$(function(){
	const toTop = $('.toTop');
	const speed = 500;

	toTop.hide(); // ボタン非表示（初期値）

	// ボタン表示・非表示の記述
	$(window).on('scroll', function(){ // スクロールした時のイベント
		if ($(this).scrollTop() > 1) { // もし、1pxスクロールすると
			toTop.fadeIn(speed); // ボタンを表示する
		} else { // それ以外は
			toTop.fadeOut(speed); // ボタンを表示しない（画面上部）
		}
	});

	// 画面上部へスクロールする記述
	toTop.on('click', function(){ // ボタンをクリックすると、
		$('body, html').animate({
		scrollTop: 0}, speed); // スクロールして画面上部へ戻る(0)
		return false;
	});
});